import { useEffect } from 'react';

// Syncs --app-height to the visual viewport so full-height shells shrink when the
// keyboard opens (iOS / kiosk WKWebView don't honor interactive-widget).
const useViewportHeight = () => {
  useEffect(() => {
    const vv = typeof window !== 'undefined' ? window.visualViewport : null;

    const sync = () => {
      const height = vv?.height ?? window.innerHeight;
      document.documentElement.style.setProperty('--app-height', `${height}px`);
    };

    sync();

    if (vv) {
      vv.addEventListener('resize', sync);
      vv.addEventListener('scroll', sync);
    }
    window.addEventListener('resize', sync);
    window.addEventListener('orientationchange', sync);

    return () => {
      if (vv) {
        vv.removeEventListener('resize', sync);
        vv.removeEventListener('scroll', sync);
      }
      window.removeEventListener('resize', sync);
      window.removeEventListener('orientationchange', sync);
    };
  }, []);
};

export default useViewportHeight;
